<template>
  <div class="d-flex flex-column flex-root" v-if="isAuthenticated">
    <vue-confirm-dialog></vue-confirm-dialog>
    <!-- begin:: Header Mobile -->
    <KTHeaderMobile></KTHeaderMobile>
    <!-- end:: Header Mobile -->

    <Loader v-if="isLoading" v-bind:logo="loaderLogo"></Loader>



    <!-- begin::Body -->
    <div class="d-flex flex-row flex-column-fluid page">
      <!-- begin:: Aside Left -->
      <KTAside v-if="asideEnabled"></KTAside>
      <!-- end:: Aside Left -->

      <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
        <!-- begin:: Content -->
        <div
          id="kt_content"
          class="content d-flex flex-column flex-column-fluid"
        >
          <!-- begin:: Content Head -->

          <!-- begin:: Content Head -->
          <KTSubheader
            v-if="subheaderDisplay"
            v-bind:breadcrumbs="breadcrumbs"
            v-bind:title="pageTitle"
          />
          <!-- end:: Content Head -->

          <!-- begin:: Content Body -->
          <div class="d-flex flex-column-fluid">
            <div
              :class="{
                'container-fluid': contentFluid,
                container: !contentFluid,
              }"
            >
              <transition name="fade-in-up">
                <router-view />
              </transition>
            </div>
          </div>
        </div>

        <KTFooter></KTFooter>
      </div>
    </div>
    <KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar>
    <KTScrollTop></KTScrollTop>
    <div>
      <!-- <v-dialog v-model="modalfilial"  fullscreen
      hide-overlay
      transition="dialog-bottom-transition" >
        <template #modal-title class="">
          Escolha uma Filial
          <button
              class="btn btn-icon btn-hover-light-primary position-absolute right-0 top-0 mt-3 mr-8"
              @click="logout"
          >
            <i class="fas fa-sign-out-alt"></i>
          </button>
        </template>
        <b-table
            class="table table-head-custom table-vertical-center table-head-bg table-borderless"
            :items="lista_filiais_autorizadas"
            show-empty
            empty-html="Nenhuma filial autorizada para seu perfil</p>
              <p>Contate o administrador.</p>"
            :fields="['filial','acao']"
        >
          <template #head(acao)=""><span></span></template>
          <template #head(filial)="">
            <div>Sede</div>
          </template>
          <template #cell(acao)="{item}">
            <div class="text-right w-100">
              <a href="#" class="btn btn-icon btn-light btn-sm" @click="selectFilial(item.id)">
                <span class="svg-icon svg-icon-md svg-icon-primary">
                      <inline-svg src="media/svg/icons/Navigation/Arrow-right.svg">
                      </inline-svg>
                  </span>
              </a>
            </div>
          </template>
        </b-table>
      </v-dialog> -->

      <v-col cols="auto">
        <v-dialog
          v-model="modalfilial"
          transition="dialog-bottom-transition"
          max-width="600"
        >
          <template>
            <v-card>
              <v-card height="60px">
                <h1 class="pt-3 pl-3">Escolha uma Filial</h1>
                <button
                  class="
                    btn btn-icon btn-hover-light-primary
                    position-absolute
                    right-0
                    top-0
                    mt-3
                    mr-8
                  "
                  @click="logout"
                >
                  <i class="fas fa-sign-out-alt"></i>
                </button>
              </v-card>
              <b-table
                class="
                  table
                  table-head-custom
                  table-vertical-center
                  table-head-bg
                  table-borderless
                "
                :items="lista_filiais_autorizadas"
                show-empty
                empty-html="Nenhuma filial autorizada para seu perfil</p>
              <p>Contate o administrador.</p>"
                :fields="['filial', 'acao']"
              >
                <template #head(acao)=""><span></span></template>
                <template #head(filial)="">
                  <div>Sede</div>
                </template>
                <template #cell(acao)="{ item }">
                  <div class="text-right w-100">
                    <a
                      href="#"
                      class="btn btn-icon btn-light btn-sm"
                      @click="selectFilial(item.id)"
                    >
                      <span class="svg-icon svg-icon-md svg-icon-primary">
                        <inline-svg
                          src="media/svg/icons/Navigation/Arrow-right.svg"
                        >
                        </inline-svg>
                      </span>
                    </a>
                  </div>
                </template>
              </b-table>
              <v-card-actions class="justify-end">
                <v-btn text @click="logout">Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import Loader from "@/view/content/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/store/htmlclass.module.js";

export default {
  name: "Layout",
  components: {
    KTAside,
    KTHeaderMobile,
    KTFooter,
    KTSubheader,
    KTStickyToolbar,
    KTScrollTop,
    Loader,
  },
  data: function () {
    return {
      fullPage: true,
      container: this.$refs.loadingContainer,
      canCancel: true, // default false
      onCancel: this.yourCallbackMethod,
      color: "#7a0000",
      useSlot: true,
      loader: "spinner",
      height: 60,
      width: 60,
      backgroundColor: "#110f38",
      opacity: 0.9,
      modalfilial: false,
    };
  },
  beforeMount() {

    // initialize html element classes
    HtmlClass.init(this.layoutConfig());
  },
  mounted() {
    // show page loading

    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

    // check if current user is authenticated
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }

    // Simulate the delay page loading
    // setTimeout(() => {
    //   // Remove page loader after some time
    //   this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    // }, 2000);
  },
  created() {
    this.setFilialGuardada();
  },

  methods: {
    logout() {
      this.$router.push({ name: "login" });
      this.$store.dispatch("auth/logout");
    },
    hideModalFilial() {
      this.modalfilial = false;
    },
    async selectFilial(filialId) {
      await this.$store.dispatch("sistema/setFilial", filialId);
      await this.$store.dispatch("sistema/listar_permissoes_sede", filialId);
      // this.$store.dispatch("protocolo/listar_protocolos_tf");

      this.hideModalFilial();
    },
    async setFilialGuardada() {
      await this.$store.dispatch("sistema/setFilialGuardada");

      if (this.$store.state.sistema.lista_permissoes_filial == "") {
        await this.$store.dispatch("sistema/listar_filiais_autorizadas");

        if (this.lista_filiais_autorizadas.length == 1) {
          this.modalfilial = false;
          this.selectFilial(this.lista_filiais_autorizadas[0].id);
        } else {
          this.modalfilial = true;
        }
      }

    },
  },

  computed: {
    lista_filiais_autorizadas() {
      return Object.values(this.$store.state.sistema.lista_filiais_autorizadas);
    },
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),

    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
     loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    isLoading() {
      return this.$store.state.configEmpresa.isLoading;
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>
